class Question {
  constructor(handle, diagnostic, answersData) {
    if (handle === "" || handle === null || handle === undefined) {
      throw new Error("Question handle cannot be empty");
    }
    if (diagnostic === undefined) {
      throw new Error("Diagnostic instance cannot be empty");
    }
    this.handle = handle;
    this.diagnostic = diagnostic;
    this.questionData = {
      "html": "",
      "html-mini-diag": "",
      "json": {}
    };
    this.answersData = answersData;
    let self = this;

    //If the question handle exist inside the Diagnostic cache, used the cached data
    if (this.diagnostic._cachedQuestion[this.handle] !== undefined) {
      /* console.log("Question already in cache", this.diagnostic._cachedQuestion[this.handle]); */
      this.questionData = this.diagnostic._cachedQuestion[this.handle];
      self.render();
    } else {
      diagnostic.diagElem.classList.add('is-loading'); // Add loader
      self._extractData(this.handle).then(questionData => {
        self.questionData = questionData;
        self.diagnostic._cachedQuestion[self.handle] = questionData;
        self.render();
      });
    }
  }
  render() {
    //Render the question according to the diagnostic template
    //"full" is for the plain page diagnostic, "mini" is for the hub diagnostic

    if (this.diagnostic.template === "full") {
      document.querySelector('#diagnostic-question').innerHTML = this.questionData.html;
    } else if (this.diagnostic.template === "mini") {
      document.querySelector('.mini-diag__question').innerHTML = this.questionData['html-mini-diag'];
    }
    this.registerEvents();
    if (this.answersData) {
      // If the question has already been answered (when clicking on back button), we populate the answers
      this.populateQuestionAnswers(this.answersData);
    } else if (this.diagnostic.editData && this.diagnostic.customerDataQuestionHandles.includes(this.handle)) {
      // Else, we populate the customer data answers if the user decided to edit the diagnostic
      this.populateQuestionAnswers(this.diagnostic.editData);
    }
    this.diagnostic.diagElem.classList.remove('is-loading'); // Remove loader
  }
  registerEvents() {
    //Register the events
    document.querySelectorAll('.answer').forEach(element => {
      if (element.nodeName.toLowerCase() == "select") {
        element.addEventListener('change', event => {
          const SelectedOption = event.target.querySelector(`option[value="${event.target.value}"]`);
          this.answerQuestion({
            target: SelectedOption
          });
        });
        return;
      } else {
        element.addEventListener('click', event => {
          this.answerQuestion(event);
        });
      }
    });
    if (this.diagnostic.template === "full") {
      document.querySelector('.back-button')?.addEventListener('click', () => {
        this.previousQuestion();
      });
    }
  }
  answerQuestion(event) {
    // Answer the question
    this.diagnostic.data.answers.push({
      "handle": this.handle,
      "answer": event.target.dataset.answer
    });
    if (event.target.dataset.nextQuestion) {
      this.diagnostic._updateDataHistory();
      this.diagnostic.instanciateQuestion(event.target.dataset.nextQuestion);
    } else {
      this.diagnostic.submitDiagnostic();
    }
  }
  previousQuestion() {
    const handles = Object.keys(this.diagnostic.dataHistory);
    const lastHandle = handles[handles.length - 1];
    if (lastHandle !== this.diagnostic.initialQuestionHandle) {
      const beforeLastHandle = handles[handles.length - 2];
      this.diagnostic.data = JSON.parse(JSON.stringify(this.diagnostic.dataHistory[beforeLastHandle]));
    } else {
      // Re-set empty data when going back to the first question
      this.diagnostic.data = {
        "answers": []
      };
    }

    // Delete last data history and instanciate the previous question
    this.diagnostic.instanciateQuestion(lastHandle, this.diagnostic.dataHistory[lastHandle]);
    delete this.diagnostic.dataHistory[lastHandle];
  }
  populateQuestionAnswers(answersData) {
    // Add selected status on previously selected answers
    let answer = answersData.answers.find(answer => answer.handle == this.handle);
    let answerElem = this.diagnostic.diagElem.querySelector(`.answer[data-answer="${answer.answer}"]`);
    if (answer && answerElem) {
      answerElem.classList.add('is-answered');
    }
  }
  async _cacheNextQuestions(answers) {
    answers.forEach(answer => {
      if (answer.next_question !== undefined && this.diagnostic._cachedQuestion[answer.next_question] == undefined) {
        this._extractData(answer.next_question).then(questionData => {
          this.diagnostic._cachedQuestion[answer.next_question] = questionData;
          /* console.log("Question cached", questionData); */
        });
      }
    });
  }
  async _extractData(handle) {
    try {
      const response = await fetch(`${window.Shopify.routes.root}pages/question/${handle}/?sections=main-question,main-question-json,main-question-hub`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();

      // We use a trick to get the json data
      // We create a div to be able to inject the html returned by the render section api
      // That's allow us to use querySelector to get the json data. 
      let json = document.createElement('div');
      json.innerHTML = data['main-question-json'];
      json = JSON.parse(json.querySelector('#question-json').innerHTML);
      let questionData = {};
      questionData.html = data['main-question'];
      questionData['html-mini-diag'] = data['main-question-hub'];
      questionData.json = json;
      this._cacheNextQuestions(questionData.json.answers);
      return questionData;
    } catch (error) {
      console.error(error);
    }
  }
}